import { apiRequest } from "./apiService";

export async function fetchDealershipInventoryList(dealershipId) {
  try {
    const res = await apiRequest(
      `/dealership/getinventorylist/${dealershipId}`,
      "GET"
    );
    return res || { inventoryList: [] };
  } catch (error) {
    console.log(error);
    return { inventoryList: [] };
  }
}

export async function getSalespeopleByDealership(dealershipId) {
  if (!dealershipId) return [];
  try {
    const res = await apiRequest(
      `/dealership/${dealershipId}/salespeople`,
      "GET"
    );
    return res?.salesPeople || [];
  } catch (error) {
    console.error("Error fetching salespeople:", error);
    return [];
  }
}

export async function fetchVehicleVPOG(params) {
  try {
    const res = await apiRequest(`/dealership/vpogs?${params}`, "GET");
    return res || { data: { success: false, url: "" } };
  } catch (error) {
    console.log(error);
    return { data: { success: false, url: "" } };
  }
}

export async function fetchVehicleTrims(dealershipId, params) {
  try {
    const res = await apiRequest(
      `/dealership/trims/${dealershipId}?${params}`,
      "GET"
    );
    return res || { trims: [] };
  } catch (error) {
    console.log(error);
    return { trims: [] };
  }
}
